import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";

export const optionShape = ImmutablePropTypes.contains({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    label: PropTypes.string,
});
